const initialState = {
  notIsFirstAccess: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'NOTISFIRSTACCESS':
      const { notIsFirstAccess } = action;
      return {
        ...state,
        notIsFirstAccess,
      };
    default:
      return state;
  }
};

export const setNotIsFirstAccess = (
  notIsFirstAccess,
) => ({
  type: 'NOTISFIRSTACCESS',
  notIsFirstAccess,
});
